const { default: axiosInstance } = require('src/components/hooks/auth/axiosInstance');

export const updateContent = async (contentId, payload, locale) => {
  let result;
  try {
    // Try the PATCH request first
    result = await axiosInstance.patch(
      `${process.env.REACT_APP_API_BASE_URL}/categories/${contentId}/content?locale=${locale}`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('sessionToken')}`,
        },
      }
    );
  } catch (error) {
    // If PATCH fails with status 405 or 404, try POST instead
    if (
      error.response &&
      (error.response.status === 405 || error.response.status === 404)
    ) {
      console.log('PATCH failed, trying POST instead...');
      result = await axiosInstance.post(
        `${process.env.REACT_APP_API_BASE_URL}/categories/${contentId}/content?locale=${locale}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('sessionToken')}`,
            'Content-Type': 'application/json',
          },
        }
      );
    } else {
      // Re-throw the error if it's not 405 or 404
      throw error;
    }
  }
  return result;
};

export const imageUpload = (e, setImages) => {
  const selectedFile = e.target.files[0];

  if (selectedFile) {
    const reader = new FileReader();
    reader.onloadend = async () => {
      const newImage = {
        base64: reader.result,
        filename: selectedFile.name,
      };
      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_BASE_URL}/media/images`,
          {
            base64: newImage.base64,
            filename: newImage.filename,
            alt: 'Uploaded image',
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('sessionToken')}`,
              'Content-Type': 'application/json',
            },
          }
        );
        console.log('Upload successful:', response.data);
        setImages((prevImages) => [...(prevImages || []), response.data]);
      } catch (error) {
        console.error('Upload failed:', error.message);
      }
    };
    reader.readAsDataURL(selectedFile);
  }
};
